<section class="container bgWhite">
   <section class="col-md-12 col-sm-12 col-xs-12">
      <div class="manage-week">
         <form [formGroup]="fileUploadForm">
            <h4>STS Shipping Customer Upload</h4>
            <p>Upload Customer Participation Data</p>
            <div class="browse-btn-group">
               <div class="wrapper">
                  <input readonly type="text" formControlName="excelUploadFile">
                  <input id="sts-input-file" name="excelFile" type="file" class="hide" (change)="onFileSelect($event)"
                     #fileUpload>
                  <button type="button" class="btn btn-primary browse-btn stsblue-button" id="browse-btn"
                     data-di-id="#browse-btn" (click)="refreshValue(); fileUpload.click();">Browse</button>
               </div>
            </div>
            <button type="button" class="btn btn-primary browse-btn stsblue-button upload" (click)="openModal(content)"
               [disabled]="fileUploadForm.invalid || !fileUploadForm.get('excelUploadFile').value || excelFileInvalidStatus">Upload</button>
            <button type="button" class="btn btn-primary stsblue-button export" (click)="downloadExcel()">Export to
               Excel</button>
            <div class="upld-date">Last upload date: <span>{{customerDetails[0]?.lastUpdated}}</span> &nbsp;&nbsp;&nbsp;
               <span class="error">{{errorMsg}}</span>
            </div>
            <ng-template #content let-modal>
               <div class="popup-comp">
                  <div class="modal-content">
                     <div class="modal-header">
                        <h4 class="modal-title-top20" *ngIf="baseSiteId == 'vsh'"> VaccineShop</h4>
                        <h4 class="modal-title-top20" *ngIf="baseSiteId == 'vax'"> VaxServe</h4>
                     </div>
                     <div class="modal-body">
                        <p class="itemlist"> This will override the current data. Do you want to proceed? </p>
                     </div>
                     <div class="modal-footer">
                        <div class="change-request-btngrps">
                           <button type="submit" class="btn btn-primary" (click)="uploadFileDetails()"
                              [disabled]="disable">Yes</button>
                           <button type="button" class="btn btn-secondary" data-dismiss="modal"
                              (click)="hideModal()">Cancel</button>
                        </div>
                     </div>
                  </div>
               </div>
            </ng-template>
         </form>
      </div>
      <div class="col-md-12 sts-cust-upld">
         <table id="backoffice-table" class="backoffice-table display" style="width:100%">
            <thead>
               <tr class="heading">
                  <th class="cust-no">Customer Number</th>
                  <th class="tier-no">Tier</th>
                  <th class="order no-sort">Contract Number</th>
               </tr>
            </thead>
            <tbody class="datatable-row" *ngIf="customerDetails && customerDetails.length !== 0">
               <tr class="week-table-row" *ngFor="let data of customerDetails; let i = index">
                  <td class="text-center">{{data.uidNonLeadingZero}}</td>
                  <td class="text-center"> {{data.tier}}</td>
                  <td class="text-center">{{data.contractNumber}}</td>
               </tr>
            </tbody>
         </table>
      </div>
   </section>
</section>